'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './bulletin-list.routes';

export class BulletinListComponent {
  constructor(BulletinService, $state, Config) {
    'ngInject';

    const bulletinConfig = Config.getModuleConfig(Config.Modules.Bulletin);

    this.currentPage = 1;
    this.itemsPerPage = Config.getPagination("bulletin");

    this.pageTitle = Config.getPageTitleByStateWithDefault($state.current.name, "Bulletin Board");

    this.categories = bulletinConfig.getCategories();
    this.dataPerCategory = {};

    this.filter = "";

    this.BulletinService = BulletinService;

    BulletinService.query(data => {
      this.data = data;

      this.categories.forEach(cat => {
        this.dataPerCategory[cat] = this.data.filter(post => {
          return post.categories.indexOf(cat) !== -1;
        });
      });

    }, err => {
      console.log('Could not retrieve bulletin board posts from server');
    });
  }

}

export default angular.module('conduuApp.bulletinList', [uiRouter])
  .config(routes)
  .component('bulletinList', {
    template: require('./bulletin-list.html'),
    controller: BulletinListComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/bulletin/list/general/bulletin-list.component.js